import React, { useState, useEffect } from 'react'
import Layout from '../Layout'
import WarningModal from '../components-modals/WarningModal'
import Axios from 'axios'
import DetallesForm from './DetallesForm'
import SearchForm from '../components-contabilidad-analisis/SearchForm'
import Pagination from '../components-contabilidad-analisis/Pagination'
import { useDispatch, useSelector } from 'react-redux'
import Cookies from 'universal-cookie'
import { setDetallesEfectivo } from '../../app/contaSlice'
import { dateFormatter } from './DetallesForm'
import { monthFormatter } from '../components-contabilidad-analisis/Reportes'
import { getCurrentMonthRange } from '../components-contabilidad-analisis/Reportes'
import Container from '../components-layout/Container'
import DatagridDetalleRetiro from './DatagridDetalleRetiro'

const DetalleRetiro = () => {
    let runInitialFetch = true

    const searchParams = ['Empresa', 'FechaCorte', 'Usuario', 'Banco', 'CuentaBoleta', 'Boleta', 'FechaBoleta', 'ValorBoleta']
    
    
        const headersApi = useSelector((state) => state.url.headersAPI);
        const cookies = new Cookies()
        //const urlSchoolApi = cookies.get('__urlSchoolApi');

        const urlState2 = useSelector(state => state.url.urlSchoolApi)
        const urlSchoolApi = urlState2 === '' || urlState2 === undefined || urlState2 === null ? cookies.get("__urlSchoolApi") : urlState2

        
    
        const urlDetEfectivo = urlSchoolApi + '/finanzas/getdepefectivo'
    
        const configObj = {
            method: 'get',
            url: urlDetEfectivo,
            headers: headersApi,
            params: ''
        }
    
        const dispatch = useDispatch()
    
        //estados
        const [loading, setLoading] = useState(true)
        const rawData = useSelector((state) => state.conta.detalles.efectivo.data)
    
        useEffect(() => {
            if(rawData.length > 1) setLoading(false);
        }, [])
    
        //datos para renderizado condicional
        const user = useSelector(state => state.auth.user)
        const userObj = JSON.parse(user)
    
        const month = rawData[0]?.FechaCorte?.slice(0, 10).trim().split('/')[1]
        const year = rawData[0]?.FechaCorte?.slice(0, 10).trim().split('/')[2]
        const monthES = monthFormatter(month, year)
    
        //Funcion para hacer fetch 
        const fetchData = async (configObj, info) => {
            setLoading(true)
            try {
                const response = await Axios(configObj)
                dispatch(setDetallesEfectivo({ data: response.data, info: info }))
                setLoading(false)
            } catch (err) {
                console.log(err)
            }
        }
    
        const [empresas, setBodegas] = useState([]);
        useEffect(() => {
            const fetchData = async () => {
                setLoading(true);
                try {
                    const res = await Axios({
                        method: 'GET',
                        url: urlSchoolApi + '/utils/busquedas',
                        headers: headersApi,
                        params: {
                            opcion: "EMPRESAS"
                        }
                    })
    
                    setBodegas(res.data);
                    setLoading(false);
                } catch (err) {
                    console.log(err)
                }
            }
    
            fetchData();
        }, [])
    
        //Fetch inicial
        const currentMMYY = getCurrentMonthRange()
        const initParams = {
            dFecha: currentMMYY.startDate,
            aFecha: currentMMYY.endDate,
            IdEmpresa: '', //Colocar como predeterminado el COL en el formulario de detalle de Efectivo
        }
    
        useEffect(() => {
            if (runInitialFetch) {
    
                let initInfo = {
                    IdEmpresa: initParams.IdEmpresa,
                    mmyy: initParams.dFecha.slice(0, 4) + '-' + initParams.dFecha.slice(4, -2)
                }
    
                configObj.params = initParams
                fetchData(configObj, initInfo)
            }
            runInitialFetch = false
        }, [runInitialFetch])
        //Fin fetch inicial
    
        //Fetch por mmyy y empresa
        const handleSubmit = (values) => {
    
            const d = dateFormatter(values.mmyy)
            setCurrentPage(1)
    
            configObj.params = {
                dFecha: d.startDate,
                aFecha: d.endDate,
                IdEmpresa: values.IdEmpresa
            }
    
            fetchData(configObj, values)
    
        }
        //Fin de fetch por mmyy y empresa
    
    
        //Busqueda 
        const [filterData, setFilter] = useState([])
        useEffect(() => { setFilter(rawData) }, [rawData])
    
        const handleQuery = (values) => {
            doSearch(values.query.trim())
            setCurrentPage(1)
        }
    
        const doSearch = (query) => {
            if (query === null) {
                setFilter(rawData)
            } else {
                setFilter(rawData.filter((x) => {
                    return searchParams.some((y) => {
                        return x[y]?.toString().toLowerCase().indexOf(query.toLowerCase()) > -1
                    })
                }))
            }
        }
        //Fin busqueda
    
        //Paginación
        const [currentPage, setCurrentPage] = useState(1)
        const recordsPerPage = 20
    
        const indexOfLastRecord = currentPage * recordsPerPage
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage
    
        const currentRecords = filterData?.slice(indexOfFirstRecord, indexOfLastRecord)
    
        const nPages = Math.ceil(rawData?.length / recordsPerPage)
        //Fin paginación
    
        const selectedOption = useSelector(state => state.conta.detalles.efectivo.info.empresa)    
  return (
    <Layout userObj={userObj} activeTab='Revisiones'>
    <WarningModal
        open={loading ? true : false}
        image={<img src='./img/loader.gif' alt='loading' />}
        opacity='bg-opacity-100'
    />
    <Container height='h-full'>
        <div className='min-h-200 flex flex-col gap-5 pt-5 lg:pt-0'>
            <div>
                <DetallesForm
                    selectedOption={selectedOption}
                    handleSubmit={handleSubmit}
                    empresas={empresas}
                    month={month}
                    year={year}
                />
            </div>
            <div>
                <SearchForm
                    handleQuery={handleQuery}
                />
            </div>
            <div>
                <DatagridDetalleRetiro
                    data={currentRecords}
                    month={monthES}
                    year={year}
                    currentPage={currentPage}
                    recordsPerPage={recordsPerPage}
                />
                <Pagination
                    nPages={nPages}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    totalRecords={filterData?.length}
                    indexOfFirstRecord={indexOfFirstRecord}
                    indexOfLastRecord={indexOfLastRecord}
                />
            </div>
        </div>
    </Container>
</Layout>
  )
}

export default DetalleRetiro